import { InjectionToken } from "@launchtray/tsyringe-async";

export class ParamDescription<T> {
    public readonly token: InjectionToken<T>;
    public readonly instance: T;

    public constructor(token: InjectionToken<T>, instance: T) {
        this.token = token;
        this.instance = instance;
    }
}